export default "__VITE_ASSET__DaTymeMG__"